/**
 * @name crud_marketing_dashboard.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_marketing_dashboard.js
 */

//import { apiCall, getBaseDir } from './utils.js';

const XLSX = require('xlsx');
var getBaseDir = null, apiCall = null, mountSortList = null;

const MARKETING_TABLE_STARt_COLUMNS_FROM = 12;

$(function () {
    import('./utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        mountSortList = utils.mountSortList;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'marketing/dashboard')
            return;

        new MarketingDashboard(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class MarketingDashboard {
    constructor(onloadList = false, deps = {}) {
        this.deps = deps;
        this.responses = {};
        this.onlyFranchise = false;
        this.periods = {
            'DASHBOARD': 'DEFAULT',
        }
        this.charts = {
            'GENERAL_FUNNEL': false,
            'MARKETING_LEADS_COMPARISION': false,
            'LEADS_CONVERSION_FUNNEL': false
        }
        this.responses = {
            'MARKETING_FUNNEL_PER_SELLER_EXPORT': []
        };
        this.requests = {};

        let self = this;

        if (onloadList) {
            this.loadMarketingMetrics(false)
                .then(() => {
                    console.log('render loadMarketingMetrics report')
                })
                .then(() => {
                    self.loadMarketingLastLeads(true)
                    self.loadMarketingGeneralFunnel(true)
                    self.loadMarketingPerSellerFunnel(true)
                    self.loadMarketingLeadsHistoryChart(false)
                    self.loadMarketingKPIs(false)
                    //self.loadMarketingLeadsConversion()
                    //self.loadMarketingOrganicLeadsConversion()
                });
        }

        this.bindDomEvents();
    }

    loadMarketingMetrics() {
        let self = this;
        return new Promise((resolve, reject) => {
            $(".js-marketing-insights-skeleton").block(window._loader.loading);

            this.requests['MARKETING_DASHBOARD_METRICS'] = this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: {
                    report: 'MARKETING_DASHBOARD_METRICS',
                    period: self.periods.DASHBOARD,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);
                    console.log('dashboard.js/marketing/insights', 'MARKETING_DASHBOARD_METRICS', res);

                    $(".js-marketing-insights-skeleton").unblock();
                    self.responses.MARKETING_DASHBOARD_METRICS = res.results;

                    if (!res.error) {
                        $('.js-marketing-leads').html(res.results.current_count_leads);
                        $('.js-schedulments').html(res.results.current_total_schedules);
                        $('.js-marketing-pn').html(res.results.current_total_pn);
                        $('.js-marketing-pit').html(res.results.current_total_pit);
                        $('.js-marketing-pim').html(res.results.current_total_pim);
                        $('.js-cancelled').html(res.results.current_total_pn_cancelled);
                        $('.js-rescheduled').html(res.results.current_total_pn_rescheduled);
                        $('.js-not-attended').html(res.results.current_total_pn_not_attended);
                        $('.js-marketing-average-3-sessions').html(res.results.current_average_3_sessions);

                        // Replace these values with your actual data
                        let currentMonthTotal = parseInt(res.results.current_count_leads); // Total for the current month
                        let previousMonthTotal = parseInt(res.results.past_count_leads); // Total for the previous mont;

                        // Calculate the percentage difference
                        let calc = ((currentMonthTotal - previousMonthTotal) / previousMonthTotal) * 100;
                        if (!isFinite(calc)) {
                            calc = 100;
                        }
                        $('.js-marketing-leads-percentage').html(`${calc.toFixed(2)}%`);
                        $('.js-marketing-leads-tooltip').attr('data-tippy-content', 'Total de leads deste período ' + (calc > 0 ? 'aumentou' : 'diminuiu') + ' em relação ao mesmo período passado onde tiveram ' + previousMonthTotal + ' leads.');
                        self.updateMarketingDashboardPercentagemColors('.js-marketing-leads-percentage', calc.toFixed(2));

                        // Calculate the percentage difference
                        calc = ((res.results.current_total_schedules - res.results.past_total_schedules) / res.results.past_total_schedules) * 100;
                        if (!isFinite(calc)) {
                            calc = 100;
                        }
                        $('.js-mkt-total-schedulments-percentage').html(`${calc.toFixed(2)}%`);
                        $('.js-mkt-total-schedulments-tooltip').attr('data-tippy-content', 'Total de agendamentos deste período ' + (calc > 0 ? 'aumentou' : 'diminuiu') + ' em relação ao mesmo período passado onde tiveram ' + res.results.past_total_schedules + ' agendamentos.');
                        self.updateMarketingDashboardPercentagemColors('.js-mkt-total-schedulments-percentage', calc.toFixed(2));

                        // Calculate the percentage difference
                        calc = ((parseInt(res.results.current_total_pn) - parseInt(res.results.past_total_pn)) / parseInt(res.results.past_total_pn)) * 100;
                        if (!isFinite(calc)) {
                            calc = 100;
                        }
                        $('.js-marketing-pn-percentage').html(`${calc.toFixed(2)}%`);
                        $('.js-marketing-pn-percentage-tooltip').attr('data-tippy-content', 'Total de PNs deste período ' + (calc > 0 ? 'aumentou' : 'diminuiu') + ' em relação ao mesmo período passado onde tiveram ' + res.results.past_total_pn + ' PNs.');
                        self.updateMarketingDashboardPercentagemColors('.js-marketing-pn-percentage', calc.toFixed(2));

                        // Calculate the percentage difference
                        calc = ((res.results.current_total_pn_cancelled - res.results.past_total_pn_cancelled) / res.results.past_total_pn_cancelled) * 100;
                        if (!isFinite(calc)) {
                            calc = 100;
                        }
                        $('.js-cancelled-percentage').html(`${calc.toFixed(2)}%`);
                        $('.js-cancelled-tooltip').attr('data-tippy-content', 'Total de PNs cancelados deste período ' + (calc > 0 ? 'aumentou' : 'diminuiu') + ' em relação ao mesmo período passado onde tiveram ' + res.results.past_total_pn_cancelled + ' PNs cancelados.');
                        self.updateMarketingDashboardPercentagemColors('.js-cancelled-percentage', calc.toFixed(2), true);

                        // Calculate the percentage difference
                        calc = ((res.results.current_total_pn_rescheduled - res.results.past_total_pn_rescheduled) / res.results.past_total_pn_rescheduled) * 100;
                        if (!isFinite(calc)) {
                            calc = 100;
                        }
                        $('.js-rescheduled-percentage').html(`${calc.toFixed(2)}%`);
                        $('.js-rescheduled-tooltip').attr('data-tippy-content', 'Total de PNs reagendados deste período ' + (calc > 0 ? 'aumentou' : 'diminuiu') + ' em relação ao mesmo período passado onde tiveram ' + res.results.past_total_pn_cancelled + ' PNs cancelados.');
                        self.updateMarketingDashboardPercentagemColors('.js-rescheduled-percentage', calc.toFixed(2), true);

                        // Calculate the percentage difference
                        calc = ((res.results.current_total_pn_not_attended - res.results.past_total_pn_not_attended) / res.results.past_total_pn_not_attended) * 100;
                        if (!isFinite(calc)) {
                            calc = 100;
                        }
                        $('.js-not-attended-percentage').html(`${calc.toFixed(2)}%`);
                        $('.js-not-attended-tooltip').attr('data-tippy-content', 'Total de PNs não atendidos deste período ' + (calc > 0 ? 'aumentou' : 'diminuiu') + ' em relação ao mesmo período passado onde tiveram ' + res.results.past_total_pn_not_attended + ' PNs não atendidos.');
                        self.updateMarketingDashboardPercentagemColors('.js-not-attended-percentage', calc.toFixed(2), true);

                        // Calculate the percentage difference
                        calc = ((parseInt(res.results.current_total_pit) - parseInt(res.results.past_total_pit)) / parseInt(res.results.past_total_pit)) * 100;
                        if (!isFinite(calc)) {
                            calc = 100;
                        }
                        $('.js-marketing-pit-percentage').html(`${calc.toFixed(2)}%`);
                        $('.js-marketing-pit-tooltip').attr('data-tippy-content', 'Total de PITs deste período ' + (calc > 0 ? 'aumentou' : 'diminuiu') + ' em relação ao mesmo período passado onde tiveram ' + res.results.past_total_pit + ' PITs.');
                        self.updateMarketingDashboardPercentagemColors('.js-marketing-pit-percentage', calc.toFixed(2));

                        // Calculate the percentage difference
                        calc = ((parseInt(res.results.current_total_pim) - parseInt(res.results.past_total_pim)) / parseInt(res.results.past_total_pim)) * 100;
                        if (!isFinite(calc)) {
                            calc = 100;
                        }
                        $('.js-marketing-pim-percentage').html(`${calc.toFixed(2)}%`);
                        $('.js-marketing-pim-tooltip').attr('data-tippy-content', 'Total de PIMs deste período ' + (calc > 0 ? 'aumentou' : 'diminuiu') + ' em relação ao mesmo período passado onde tiveram ' + res.results.past_total_pim + ' PIMs.');
                        self.updateMarketingDashboardPercentagemColors('.js-marketing-pim-percentage', calc.toFixed(2));

                        let mktInvesmentsTableHtml = '';
                        self.mktInvestmentsTotals = {
                            'GOOGLE': 0,
                            'FACEBOOK': 0,
                            'SOCIAL': 0,
                            'WHATSAPP': 0
                        };
                        for (let i in res.results.current_marketing_invesments) {
                            let invesment = res.results.current_marketing_invesments[i];
                            mktInvesmentsTableHtml += `<tr>
                                <td>${invesment.DATE.split(" ")[0]}</td>
                                <td>${invesment.GOOGLE}</td>
                                <td>${invesment.FACEBOOK}</td>
                                <td>${invesment.SOCIAL}</td>
                                <td>${invesment.WHATSAPP}</td>
                            </tr>`;
                            self.mktInvestmentsTotals['GOOGLE'] += parseInt(invesment.GOOGLE);
                            self.mktInvestmentsTotals['FACEBOOK'] += parseInt(invesment.FACEBOOK);
                            self.mktInvestmentsTotals['SOCIAL'] += parseInt(invesment.SOCIAL);
                            self.mktInvestmentsTotals['WHATSAPP'] += parseInt(invesment.WHATSAPP);
                        }
                        mktInvesmentsTableHtml += `<tr>
                            <td><strong>Total</strong></td>
                            <td><strong>${self.mktInvestmentsTotals['GOOGLE']}</strong></td>
                            <td><strong>${self.mktInvestmentsTotals['FACEBOOK']}</strong></td>
                            <td><strong>${self.mktInvestmentsTotals['SOCIAL']}</strong></td>
                            <td><strong>${self.mktInvestmentsTotals['WHATSAPP']}</strong></td>
                        </tr>`;
                        $('.js-mkt-invesments-table').html(mktInvesmentsTableHtml);

                        let pnOriginsTableHtml = '';
                        for (let i in res.results.current_pn_origins) {
                            let origin = res.results.current_pn_origins[i];
                            pnOriginsTableHtml += `<tr class="js-report-marketing-pn-schedules-origins" data-origin-id="${origin.ORIGEM_NAME}" data-type="PN-TOTAL-SCHEDULES">
                                <td>${origin.ORIGEM_NAME}</td>
                                <td>${origin.TOTAL_SCHEDULES}</td>
                            </tr>`;
                        }
                        $('.js-mkt-leads-origins-table').html(pnOriginsTableHtml);

                        pnAttendedOriginsTableHtml = '';
                        for (let i in res.results.current_pn_attended_origins) {
                            let origin = res.results.current_pn_attended_origins[i];
                            let conversionFromPnSchedules = self.getOriginConversionRate(origin.ORIGEM_NAME, Number(origin.TOTAL_SCHEDULES), res.results.current_pn_origins)

                            pnAttendedOriginsTableHtml += `<tr class="js-report-marketing-pn-schedules-origins" data-origin-id="${origin.ORIGEM_NAME}" data-type="PN-TOTAL-SCHEDULES-ATTENDED">
                                <td>${origin.ORIGEM_NAME}<br><small>(Conv: ${conversionFromPnSchedules}%)</small></td>
                                <td>${origin.TOTAL_SCHEDULES}</td>
                            </tr>`;
                        }
                        $('.js-mkt-leads-pn-attended-origins-table').html(pnAttendedOriginsTableHtml);

                        pnAttendedOriginsTableHtml = '';
                        for (let i in res.results.current_pit_attended_origins) {
                            let origin = res.results.current_pit_attended_origins[i];
                            let conversionFromAttendedPnToPit = self.getOriginConversionRate(origin.ORIGEM_NAME, Number(origin.TOTAL_SCHEDULES), res.results.current_pn_attended_origins)

                            pnAttendedOriginsTableHtml += `<tr class="js-report-marketing-pn-schedules-origins" data-origin-id="${origin.ORIGEM_NAME}" data-type="PIT-TOTAL">
                                <td>${origin.ORIGEM_NAME}<br><small>(Conv: ${conversionFromAttendedPnToPit}%)</small></td>
                                <td>${origin.TOTAL_SCHEDULES}</td>
                            </tr>`;
                        }
                        $('.js-mkt-leads-pit-attended-origins-table').html(pnAttendedOriginsTableHtml);

                        pnAttendedOriginsTableHtml = '';
                        for (let i in res.results.current_pim_attended_origins) {
                            let origin = res.results.current_pim_attended_origins[i];
                            let conversionFromAttendedPnToPit = self.getOriginConversionRate(origin.ORIGEM_NAME, Number(origin.TOTAL_SCHEDULES), res.results.current_pn_attended_origins)

                            pnAttendedOriginsTableHtml += `<tr class="js-report-marketing-pn-schedules-origins" data-origin-id="${origin.ORIGEM_NAME}" data-type="PIT-TOTAL">
                                <td>${origin.ORIGEM_NAME}<br><small>(Conv: ${conversionFromAttendedPnToPit}%)</small></td>
                                <td>${origin.TOTAL_SCHEDULES}</td>
                            </tr>`;
                        }
                        $('.js-mkt-leads-pim-attended-origins-table').html(pnAttendedOriginsTableHtml);
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    getOriginConversionRate(originName, originTotalSchedules, comparision_data) {
        let conversionRate = 0;
        for (let i in comparision_data) {
            let origin = comparision_data[i];
            if (origin.ORIGEM_NAME === originName) {
                conversionRate = parseFloat((originTotalSchedules / origin.TOTAL_SCHEDULES) * 100).toFixed(2);
                break;
            }
        }
        return conversionRate;
    }

    updateMarketingDashboardPercentagemColors(div_class, percentage, reverse = false) {
        $(div_class).removeClass('text-success');
        $(div_class).removeClass('text-danger');
        $(div_class).removeClass('text-primary');
        if (percentage > 0) {
            $(div_class).html(`+${percentage}%`);
            if (!reverse)
                $(div_class).addClass('text-success');
            else
                $(div_class).addClass('text-danger');
        } else if (percentage < 0) {
            $(div_class).html(`${percentage}%`);
            if (!reverse)
                $(div_class).addClass('text-danger');
            else
                $(div_class).addClass('text-success');
        } else {
            $(div_class).html(`0%`);
            if (!reverse)
                $(div_class).addClass('text-primary');
            else
                $(div_class).addClass('text-secondary');
        }
    }

    loadMarketingLastLeads() {
        let self = this;
        return new Promise((resolve, reject) => {
            $(".js-marketing-insights-skeleton").block(window._loader.loading);

            this.requests['MARKETING_DASHBOARD_LAST_LEADS'] = this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: {
                    report: 'MARKETING_DASHBOARD_LAST_LEADS',
                    period: self.periods.DASHBOARD,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);
                    console.log('dashboard.js/marketing/insights', 'MARKETING_DASHBOARD_LAST_LEADS', res);

                    $(".js-marketing-insights-skeleton").unblock();
                    self.responses.MARKETING_DASHBOARD_LAST_LEADS = res.results;

                    if (!res.error) {
                        let lastLeadsListHtml = '';
                        for (let i in res.results) {
                            let lead = res.results[i];
                            lastLeadsListHtml += `
                                <div class="col">
                                    <div class="card-shadow-primary mb-3 widget-chart widget-chart2 text-left card">
                                        <div class="widget-chat-wrapper-outer">
                                            <div class="widget-chart-content">
                                                <h6 class="widget-subheading"><a href="${window._baseDir}marketing/lead/${lead.ID}">${lead.NOME}</a></h6>
                                                <div class="">
                                                    <div class="mb-0 w-100">
                                                        <div class="">
                                                            <div class="fsize-4">
                                                                <small class="opacity-5"></small>
                                                                <span style="font-size:12px;">${lead.LOCAL_CONVERSAO}</span>
                                                            </div>
                                                            <div class="ml-auto">
                                                                <div class="widget-title ml-auto font-size-lg font-weight-normal text-muted">
                                                                    <span class="text-secondary" style="font-size:12px;">${moment(parseInt(lead.CADASTRO_DATA) * 1000).format('DD/MM/YYYY')} às ${moment(parseInt(lead.CADASTRO_DATA) * 1000).format('HH:mm')}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            `;
                        }
                        $('.js-marketing-leads-list').html(lastLeadsListHtml);
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadMarketingGeneralFunnel() {
        let self = this;
        return new Promise((resolve, reject) => {
            $("#js-report-marketing-general-funnel").block(window._loader.loading);

            this.requests['MARKETING_DASHBOARD_GENERAL_FUNNEL'] = this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: {
                    report: 'MARKETING_DASHBOARD_GENERAL_FUNNEL',
                    period: self.periods.DASHBOARD,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);
                    console.log('dashboard.js/marketing/insights', 'MARKETING_DASHBOARD_GENERAL_FUNNEL', res);

                    $("#js-report-marketing-general-funnel").unblock();
                    self.responses.MARKETING_DASHBOARD_GENERAL_FUNNEL = res.results;

                    // Calculate the percentages
                    const totalLeads = self.responses.MARKETING_DASHBOARD_METRICS.current_count_leads;
                    const contactedLeads = res.results.funnel_start_count.funil_entrou_em_contato;
                    const percentageContacted = parseFloat((contactedLeads / totalLeads) * 100).toFixed(2);
                    const percentageScheduled = parseFloat((self.responses.MARKETING_DASHBOARD_METRICS.current_total_schedules / contactedLeads) * 100).toFixed(2);
                    const percentageNewPatients = parseFloat((self.responses.MARKETING_DASHBOARD_METRICS.current_total_pn / contactedLeads) * 100).toFixed(2);
                    const percentagePlansSold = parseFloat((self.responses.MARKETING_DASHBOARD_METRICS.current_total_pit / self.responses.MARKETING_DASHBOARD_METRICS.current_total_pn) * 100).toFixed(2);

                    if (!res.error) {
                        var options = {
                            series: [
                                {
                                    name: "Funil",
                                    data: [
                                        totalLeads,
                                        res.results.funnel_start_count.funil_entrou_em_contato,
                                        self.responses.MARKETING_DASHBOARD_METRICS.current_total_schedules,
                                        self.responses.MARKETING_DASHBOARD_METRICS.current_total_pn,
                                        self.responses.MARKETING_DASHBOARD_METRICS.current_total_pit
                                    ],
                                },
                            ],
                            chart: {
                                type: 'bar',
                                height: 350,
                            },
                            plotOptions: {
                                bar: {
                                    borderRadius: 0,
                                    horizontal: true,
                                    barHeight: '80%',
                                    isFunnel: true,
                                },
                            },
                            dataLabels: {
                                enabled: true,
                                formatter: function (val, opt) {
                                    return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val
                                },
                                dropShadow: {
                                    enabled: true,
                                },
                            },
                            title: {
                                text: 'Funil Pacientes',
                                align: 'middle',
                            },
                            xaxis: {
                                categories: [
                                    'Total de Leads - 100%',
                                    'Leads Contatados - ' + (percentageContacted) + '%',
                                    'Agendamentos - ' + (percentageScheduled) + '%',
                                    'PN - ' + (percentageNewPatients) + '%',
                                    'PIT - ' + (percentagePlansSold) + '%'
                                ],
                            },
                            legend: {
                                show: false,
                            },
                        };

                        if (!self.charts.GENERAL_FUNNEL) {
                            self.charts.GENERAL_FUNNEL = new ApexCharts(document.querySelector("#js-report-marketing-general-funnel"), options);
                            self.charts.GENERAL_FUNNEL.render();
                        } else {
                            self.charts.GENERAL_FUNNEL.updateOptions(options);
                        }
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadMarketingPerSellerFunnel() {
        let self = this;
        return new Promise((resolve, reject) => {
            $("#js-report-marketing-branches-funnel").block(window._loader.loading);

            this.requests['MARKETING_DASHBOARD_PER_SELLER_FUNNEL'] = this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: {
                    report: 'MARKETING_DASHBOARD_PER_SELLER_FUNNEL',
                    period: self.periods.DASHBOARD,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);
                    console.log('dashboard.js/marketing/insights', 'MARKETING_DASHBOARD_PER_SELLER_FUNNEL', res);

                    $("#js-report-marketing-branches-funnel").unblock();
                    self.responses.MARKETING_DASHBOARD_PER_SELLER_FUNNEL = res;

                    if (!res.error) {
                        self.responses['MARKETING_FUNNEL_PER_SELLER_EXPORT'] = [];

                        let countExtraOrigins = MARKETING_TABLE_STARt_COLUMNS_FROM;

                        let mountHtml0 = '', mountHtml1 = '', mountHtml2 = '';

                        window._sessionData.organicAttendantList.map((v, i) => {
                            mountHtml0 += `<th class="js-mkt-branches-funnel-column-${countExtraOrigins} ${window._sessionData.activeOrganicAttendantList.includes(v) ? '' : 'column-hideable'}">PNs (${v})</th>`;
                            countExtraOrigins++;

                            mountHtml0 += `<th class="js-mkt-branches-funnel-column-${countExtraOrigins} ${window._sessionData.activeOrganicAttendantList.includes(v) ? '' : 'column-hideable'}">PITs (${v})</th>`;
                            countExtraOrigins++;
                        })

                        countExtraOrigins = countExtraOrigins - 1;

                        window._sessionData.origins.map(
                            (v) => {
                                if (v.ID != 8) {
                                    countExtraOrigins++;
                                    mountHtml1 += `<th class="js-mkt-branches-funnel-column-${countExtraOrigins - 1} column-hideable">PNs (${v.ORIGEM})</th>`
                                }
                            }
                        )
                        window._sessionData.origins.map(
                            (v) => {
                                if (v.ID != 8) {
                                    countExtraOrigins++;
                                    mountHtml2 += `<th class="js-mkt-branches-funnel-column-${countExtraOrigins - 1} column-hideable">PITs (${v.ORIGEM})</th>`
                                }
                            }
                        )

                        $('#js-report-marketing-branches-funnel').html(`
                            <table id="table-js-report-marketing-branches-funnel-list" class="tableFixHead mb-0 table table-bordered table-striped table-hover ${!window.mobileCheck() ? 'table-responsive' : ''} responsive-table" style="height:auto !important;">
                                <thead>
                                    <tr>
                                        <th class="">Filial</th>
                                        <th class="js-mkt-branches-funnel-column-1">Gráfico</th>
                                        <th class="js-mkt-branches-funnel-column-2">Total Leads</th>
                                        <th class="js-mkt-branches-funnel-column-3 column-hideable">Total Leads (Hunter)</th>
                                        <th class="js-mkt-branches-funnel-column-4 column-hideable">Total Leads (Clínica)</th>
                                        <th class="js-mkt-branches-funnel-column-5 column-hideable">Total Leads (Ambos)</th>
                                        <th class="js-mkt-branches-funnel-column-6">Leads Contatados</th>
                                        <th class="js-mkt-branches-funnel-column-7">Leads Não Contatados</th>
                                        <th class="js-mkt-branches-funnel-column-8 column-hideable">PNs (Hunters)</th>
                                        <th class="js-mkt-branches-funnel-column-9 column-hideable">PITs (Hunters)</th>
                                        <th class="js-mkt-branches-funnel-column-10">PNs (Clínica)</th>
                                        <th class="js-mkt-branches-funnel-column-11">PITs (Clínica)</th>
                                        ${mountHtml0}
                                        ${mountHtml1}
                                        ${mountHtml2}
                                        <th class="js-mkt-branches-funnel-column-${countExtraOrigins}">PNs</th>
                                        <th class="js-mkt-branches-funnel-column-${countExtraOrigins + 1}">PITs</th>
                                        <th class="js-mkt-branches-funnel-column-${countExtraOrigins + 2}">PIMs</th>
                                        <th class="js-mkt-branches-funnel-column-${countExtraOrigins + 3}">PRs</th>
                                    </tr>
                                </thead>
                                <tbody class="js-report-marketing-branches-funnel-list">
                                    <tr><td colspan="${countExtraOrigins}">Carregando...</td></tr>
                                </tbody>
                                <tfoot class="js-report-marketing-branches-funnel-footer">

                                </tfoot>
                            </table>
                        `);

                        let html = '',
                            countIdx = 0,
                            countTotalLeads = 0,
                            countTotalLeadsHunter = 0,
                            countTotalLeadsClinica = 0,
                            countTotalLeadsAmbos = 0,
                            countTotaLeadsContatados = 0,
                            countTotalNaoLeadsContatados = 0,
                            countTotalPN = 0,
                            countTotalPNHunter = 0,
                            countTotalPNBot = [],
                            countTotalPNBot2 = 0,
                            countTotalPNBot3 = 0,
                            countTotalPNBot4 = 0,
                            countTotalPNByBusinessBranh = 0,
                            countTotalPIT = 0,
                            countTotalPITHunter = 0,
                            countTotalPITClinica = 0,
                            countTotalPITRobo = [],
                            countTotalPITRoboJeff = 0,
                            countTotalPITRoboAdri = 0,
                            countTotalPITRoboJoaoVitor = 0,
                            foundBranches = [],
                            notFoundBranches = [],
                            countTotalPlanSells = 0,
                            countTotalPlanMaintenanceSells = 0,
                            countTotalPR = 0,
                            countOriginsTotals = {},
                            countOriginsTotalsPIT = {};

                        $('.js-report-marketing-branches-funnel-list').html('');
                        for (let i = 0; i < Object.entries(self.responses.MARKETING_DASHBOARD_PER_SELLER_FUNNEL.results).length; ++i) {
                            const filial = Object.keys(self.responses.MARKETING_DASHBOARD_PER_SELLER_FUNNEL.results)[i];
                            if (filial === 'THE QUIRO')
                                continue;

                            const data = Object.entries(self.responses.MARKETING_DASHBOARD_PER_SELLER_FUNNEL.results)[i][1];

                            let calcHunterVsTotal = parseFloat(((data.funnel.funil_total - data.funnel.funil_total_hunters) / data.funnel.funil_total_hunters) * 100).toFixed(2);
                            if (!isFinite(calcHunterVsTotal)) {
                                calcHunterVsTotal = 100;
                            }

                            let calcClinicaVsTotal = parseFloat(((data.funnel.funil_total - data.funnel.funil_total_clinica) / data.funnel.funil_total_clinica) * 100).toFixed(2);
                            if (!isFinite(calcClinicaVsTotal)) {
                                calcClinicaVsTotal = 100;
                            }

                            let calcLeadsContatadosVsLeadsTotal = parseFloat(((data.funnel.funil_entrou_em_contato / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcLeadsContatadosVsLeadsTotal)) {
                                calcLeadsContatadosVsLeadsTotal = 100;
                            }

                            let calcLeadsNaoContatadosVsLeadsTotal = parseFloat(((data.funnel.funil_nao_entrou_em_contato / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcLeadsNaoContatadosVsLeadsTotal)) {
                                calcLeadsNaoContatadosVsLeadsTotal = 100;
                            }

                            let calcAgendamentosHuntersVsLeadsTotal = parseFloat(((data.funnel.current_total_scheduled / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcAgendamentosHuntersVsLeadsTotal)) {
                                calcAgendamentosHuntersVsLeadsTotal = 100;
                            }
                            let calcPlanosHuntersVsLeadsTotal = parseFloat(((data.current_total_plan_sells_by_seller.TOTAL_PIT_HUNTER / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcPlanosHuntersVsLeadsTotal)) {
                                calcPlanosHuntersVsLeadsTotal = 100;
                            }

                            let calcAgendamentosClinicaVsLeadsTotal = parseFloat(((data.funnel.current_total_scheduled_by_business_branch / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcAgendamentosClinicaVsLeadsTotal)) {
                                calcAgendamentosClinicaVsLeadsTotal = 100;
                            }
                            let calcPlanosClinicaVsLeadsTotal = parseFloat(((data.current_total_plan_sells_by_seller.TOTAL_PIT_CLINICA / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcPlanosClinicaVsLeadsTotal)) {
                                calcPlanosClinicaVsLeadsTotal = 100;
                            }

                            let calcAgendamentosRobo1VsLeadsTotal = parseFloat(((data.funnel.current_total_scheduled_bot / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcAgendamentosRobo1VsLeadsTotal)) {
                                calcAgendamentosRobo1VsLeadsTotal = 100;
                            }
                            let calcPlanosRobo1VsLeadsTotal = parseFloat(((data.current_total_plan_sells_by_seller.TOTAL_PIT_ROBO_1 / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcPlanosRobo1VsLeadsTotal)) {
                                calcPlanosRobo1VsLeadsTotal = 100;
                            }

                            let calcAgendamentosRobo2VsLeadsTotal = parseFloat(((data.funnel.current_total_scheduled_bot_2 / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcAgendamentosRobo2VsLeadsTotal)) {
                                calcAgendamentosRobo2VsLeadsTotal = 100;
                            }
                            let calcPlanosRobo2VsLeadsTotal = parseFloat(((data.current_total_plan_sells_by_seller.TOTAL_PIT_ROBO / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcPlanosRobo2VsLeadsTotal)) {
                                calcPlanosRobo2VsLeadsTotal = 100;
                            }

                            let calcAgendamentosRobo3VsLeadsTotal = parseFloat(((data.funnel.current_total_scheduled_bot_3 / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcAgendamentosRobo3VsLeadsTotal)) {
                                calcAgendamentosRobo3VsLeadsTotal = 100;
                            }
                            let calcPlanosRobo3VsLeadsTotal = parseFloat(((data.current_total_plan_sells_by_seller.TOTAL_PIT_ROBO_2 / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcPlanosRobo3VsLeadsTotal)) {
                                calcPlanosRobo3VsLeadsTotal = 100;
                            }

                            let calcAgendamentosRobo4VsLeadsTotal = parseFloat(((data.funnel.current_total_scheduled_bot_4 / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcAgendamentosRobo4VsLeadsTotal)) {
                                calcAgendamentosRobo4VsLeadsTotal = 100;
                            }
                            let calcPlanosRobo4VsLeadsTotal = parseFloat(((data.current_total_plan_sells_by_seller.TOTAL_PIT_ROBO_3 / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcPlanosRobo4VsLeadsTotal)) {
                                calcPlanosRobo4VsLeadsTotal = 100;
                            }

                            let totalPn = parseInt(data.current_total_scheduled) + parseInt(data.current_total_scheduled_by_business_branch)

                            for (let i = 0; i < window._sessionData.organicAttendantList.length; i++) {
                                totalPn += parseInt(data[`current_total_scheduled_bot_${i}`]);
                            }

                            let calcPNVsLeadsTotal = parseFloat(((totalPn / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcPNVsLeadsTotal)) {
                                calcPNVsLeadsTotal = 100;
                            }

                            let calcPITsVsLeadsTotal = parseFloat(((data.current_total_plans_sells / data.funnel.funil_total) * 100)).toFixed(2);
                            if (!isFinite(calcPITsVsLeadsTotal)) {
                                calcPITsVsLeadsTotal = 100;
                            }

                            let extraOriginsPerRowHTML = '';
                            let extraExportOriginsData = {};
                            let extraOrganicAttendantPerRowHTML = '';
                            countExtraOrigins = MARKETING_TABLE_STARt_COLUMNS_FROM;

                            for (let i = 0; i < window._sessionData.organicAttendantList.length; i++) {
                                let vb = window._sessionData.organicAttendantList[i];
                                let calcAgendamentosRoboVsLeadsTotal = parseFloat(((data[`current_total_scheduled_bot_${i}`] / data.funnel.funil_total) * 100)).toFixed(2);
                                if (!isFinite(calcAgendamentosRoboVsLeadsTotal)) {
                                    calcAgendamentosRoboVsLeadsTotal = 100;
                                }
                                let calcPlanosRoboVsLeadsTotal = parseFloat(((data.current_total_plan_sells_by_seller[`TOTAL_PIT_ROBO_${i}`] / data.funnel.funil_total) * 100)).toFixed(2);
                                if (!isFinite(calcPlanosRoboVsLeadsTotal)) {
                                    calcPlanosRoboVsLeadsTotal = 100;
                                }

                                extraOriginsPerRowHTML += `
                                    <td class="js-mkt-branches-funnel-column-${countExtraOrigins} ${window._sessionData.activeOrganicAttendantList.includes(window._sessionData.organicAttendantList[i]) ? '' : 'column-hideable'}" data-label="Total PNs ${vb}">${data[`current_total_scheduled_bot_${i}`]} <small>(${calcAgendamentosRoboVsLeadsTotal}%)</small></td>
                                `;

                                countExtraOrigins++;

                                extraOriginsPerRowHTML += `
                                    <td class="js-mkt-branches-funnel-column-${countExtraOrigins} ${window._sessionData.activeOrganicAttendantList.includes(window._sessionData.organicAttendantList[i]) ? '' : 'column-hideable'}" data-label="Total PITs ${vb}">${data.current_total_plan_sells_by_seller[`TOTAL_PIT_ROBO_${i}`]} <small>(${calcPlanosRoboVsLeadsTotal}%)</small></td>
                                `;

                                countExtraOrigins++;
                            }

                            countExtraOrigins = countExtraOrigins - 1;

                            for (let i in window._sessionData.origins) {
                                let origin = window._sessionData.origins[i];

                                if (origin.ID == 8) // ESSA CATEGORIA DEVE SER IGNORADA POIS TEM 2 ORIGENS COM NOME LEAD
                                    continue;

                                let hasOriginData = 0;
                                //console.log('data.current_pn_attended_origins', data.current_pn_attended_origins, Object.keys(data.current_pn_attended_origins));
                                for (let j = 0; j < Object.keys(data.current_pn_attended_origins).length; j++) {
                                    let originData = data.current_pn_attended_origins[j];
                                    //console.log('originData', originData);
                                    if (!originData)
                                        continue;
                                    //console.log('originData.ORIGEM_NAME.toUpperCase() originData', originData, originData.ORIGEM_NAME.toUpperCase(), origin.ORIGEM.toUpperCase());
                                    if (origin.ORIGEM.toUpperCase() === 'INDICAÇÃO') {
                                        origin.ORIGEM = 'INDICACAO'
                                    }
                                    if (originData.ORIGEM_NAME.toUpperCase() == origin.ORIGEM.toUpperCase()) {
                                        hasOriginData = parseInt(originData.TOTAL_SCHEDULES);
                                        break;
                                    }
                                }

                                let calcAgendamentosOrigemVsLeadsTotal = parseFloat(((hasOriginData / data.funnel.funil_total) * 100)).toFixed(2);
                                if (!isFinite(calcAgendamentosOrigemVsLeadsTotal)) {
                                    calcAgendamentosOrigemVsLeadsTotal = 100;
                                }
                                extraOriginsPerRowHTML += `<td class="js-mkt-branches-funnel-column-${countExtraOrigins} column-hideable" data-label="Total PNs ${origin.ORIGEM}">${hasOriginData} <small>(${calcAgendamentosOrigemVsLeadsTotal}%)</small></td>`;
                                countExtraOrigins++;

                                extraExportOriginsData['PNs' + origin.ORIGEM.toUpperCase()] = hasOriginData
                                if (!countOriginsTotals[origin.ORIGEM.toUpperCase()]) {
                                    countOriginsTotals[origin.ORIGEM.toUpperCase()] = parseInt(hasOriginData)
                                } else {
                                    countOriginsTotals[origin.ORIGEM.toUpperCase()] += parseInt(hasOriginData);
                                }

                                /*if (origin.ORIGEM.toUpperCase() === 'LEAD')
                                    console.log('origin.ORIGEM.toUpperCase()', origin.ORIGEM.toUpperCase(), hasOriginData, countOriginsTotals[origin.ORIGEM.toUpperCase()]);*/
                            }

                            let extraExportPITOriginsData = {};
                            for (let i in window._sessionData.origins) {
                                let origin = window._sessionData.origins[i];

                                if (origin.ID == 8) // ESSA CATEGORIA DEVE SER IGNORADA POIS TEM 2 ORIGENS COM NOME LEAD
                                    continue;

                                let hasOriginData = 0;
                                //console.log('data.current_pit_attended_origins', data.current_pit_attended_origins, Object.keys(data.current_pit_attended_origins));
                                for (let j = 0; j < Object.keys(data.current_pit_attended_origins).length; j++) {
                                    let originData = data.current_pit_attended_origins[j];
                                    //console.log('originData', originData);
                                    if (!originData)
                                        continue;
                                    //console.log('originData.ORIGEM_NAME.toUpperCase() originData', originData, originData.ORIGEM_NAME.toUpperCase(), origin.ORIGEM.toUpperCase());
                                    if (origin.ORIGEM.toUpperCase() === 'INDICAÇÃO') {
                                        origin.ORIGEM = 'INDICACAO'
                                    }
                                    if (originData.ORIGEM_NAME.toUpperCase() == origin.ORIGEM.toUpperCase()) {
                                        hasOriginData = parseInt(originData.TOTAL_SCHEDULES);
                                        break;
                                    }
                                }

                                let calcAgendamentosOrigemVsLeadsTotal = parseFloat(((hasOriginData / data.funnel.funil_total) * 100)).toFixed(2);
                                if (!isFinite(calcAgendamentosOrigemVsLeadsTotal)) {
                                    calcAgendamentosOrigemVsLeadsTotal = 100;
                                }
                                extraOriginsPerRowHTML += `<td class="js-mkt-branches-funnel-column-${countExtraOrigins} column-hideable" data-label="Total PITs ${origin.ORIGEM}">${hasOriginData} <small>(${calcAgendamentosOrigemVsLeadsTotal}%)</small></td>`;
                                countExtraOrigins++;

                                extraExportPITOriginsData['PITs ' + origin.ORIGEM.toUpperCase()] = hasOriginData
                                if (!countOriginsTotalsPIT[origin.ORIGEM.toUpperCase()]) {
                                    countOriginsTotalsPIT[origin.ORIGEM.toUpperCase()] = parseInt(hasOriginData)
                                } else {
                                    countOriginsTotalsPIT[origin.ORIGEM.toUpperCase()] += parseInt(hasOriginData);
                                }

                                /*if (origin.ORIGEM.toUpperCase() === 'LEAD')
                                    console.log('origin.ORIGEM.toUpperCase()', countExtraOrigins, origin.ORIGEM.toUpperCase(), hasOriginData, countOriginsTotals[origin.ORIGEM.toUpperCase()]);*/
                            }

                            let totalAttendendPNSum = parseInt(data.current_total_scheduled) + parseInt(data.current_total_scheduled_by_business_branch);
                            window._sessionData.organicAttendantList.map((v, i) => {
                                totalAttendendPNSum += parseInt(data[`current_total_scheduled_bot_${i}`]);
                            })

                            $('.js-report-marketing-branches-funnel-list').append(`
                                <tr>
                                    <td class="js-report-row-marketing-branches-funnel-option" data-filial="${filial}" data-label="Filial">${filial}</td>
                                    <td class="js-mkt-branches-funnel-column-1" data-label="Gráfico"><i class="js-marketing-view-branch-data fas fa-eye mx-2 pe-auto user-select-none" data-filial="${filial}"></i></td>
                                    <td class="js-mkt-branches-funnel-column-2" data-label="Total Leads">${data.funnel.funil_total}</td>
                                    <td class="js-mkt-branches-funnel-column-3 column-hideable" data-label="Total Leads (Hunter)">${data.funnel.funil_total_hunters} <small>(${calcHunterVsTotal}%)</small></td>
                                    <td class="js-mkt-branches-funnel-column-4 column-hideable" data-label="Total Leads (Clínica)">${data.funnel.funil_total_clinica} <small>(${calcClinicaVsTotal}%)</small></td>
                                    <td class="js-mkt-branches-funnel-column-5 column-hideable" data-label="Total Leads (Ambos)">${data.funnel.funil_total_ambos}</td>
                                    <td class="js-mkt-branches-funnel-column-6" data-label="Leads Contatados">${data.funnel.funil_entrou_em_contato} <small>(${calcLeadsContatadosVsLeadsTotal}%)</small></td>
                                    <td class="js-mkt-branches-funnel-column-7" data-label="Leads Não Contatados">${data.funnel.funil_nao_entrou_em_contato} <small>(${calcLeadsNaoContatadosVsLeadsTotal}%)</small></td>
                                    <td class="js-mkt-branches-funnel-column-8 column-hideable" data-label="PNs (hunters)">${data.current_total_scheduled} <small>(${calcAgendamentosHuntersVsLeadsTotal}%)</small></td>
                                    <td class="js-mkt-branches-funnel-column-9 column-hideable" data-label="PITs (hunters)">${data.current_total_plan_sells_by_seller.TOTAL_PIT_HUNTER} <small>(${calcPlanosHuntersVsLeadsTotal}%)</small></td>
                                    <td class="js-mkt-branches-funnel-column-10" data-label="PNs (clínica)">${data.current_total_scheduled_by_business_branch} <small>(${calcAgendamentosClinicaVsLeadsTotal}%)</small></td>
                                    <td class="js-mkt-branches-funnel-column-11" data-label="PITs (clínica)">${data.current_total_plan_sells_by_seller.TOTAL_PIT_CLINICA} <small>(${calcPlanosClinicaVsLeadsTotal}%)</small></td>
                                    ${extraOrganicAttendantPerRowHTML}
                                    ${extraOriginsPerRowHTML}
                                    <td class="js-mkt-branches-funnel-column-${countExtraOrigins}" data-label="PNs">${totalAttendendPNSum} <small>(${calcPNVsLeadsTotal}%)</small></td>
                                    <td class="js-mkt-branches-funnel-column-${countExtraOrigins + 1}" data-label="PITs">${data.current_total_plans_sells} <small>(${calcPITsVsLeadsTotal}%)</small></td>
                                    <td class="js-mkt-branches-funnel-column-${countExtraOrigins + 2}" data-label="PIMs">${data.current_total_plans_maintenance_sells}</td>
                                    <td class="js-mkt-branches-funnel-column-${countExtraOrigins + 3}" data-label="PRs">${data.current_total_returnig_patients}</td>
                                </tr>
                            `);

                            setTimeout(function () {
                                let render = {
                                    chart: {
                                        type: "line",
                                        height: 318,
                                        width: "100%",
                                        stacked: false,
                                        foreColor: "#999"
                                    },
                                    colors: ["#fcba03", "#0384fc"],
                                    series: [{
                                        name: "PIT",
                                        data: data.chart_pit_by_dates
                                    }, {
                                        name: "PN",
                                        data: data.chart_pn_by_dates
                                    }],
                                    stroke: {
                                        curve: 'straight'
                                    },
                                    labels: data.chart_labels,
                                    xaxis: {
                                        axisBorder: {
                                            show: !1
                                        },
                                        axisTicks: {
                                            show: !1
                                        },
                                        crosshairs: {
                                            show: !1
                                        },
                                        labels: {
                                            show: false,
                                            style: {
                                                fontSize: "14px"
                                            }
                                        }
                                    },
                                    grid: {
                                        xaxis: {
                                            lines: {
                                                show: !1
                                            }
                                        },
                                        yaxis: {
                                            lines: {
                                                show: !1
                                            }
                                        }
                                    },
                                    yaxis: {
                                        axisBorder: {
                                            show: true
                                        },
                                        labels: {
                                            show: true
                                        }
                                    },
                                    legend: {
                                        showForSingleSeries: true,
                                        position: 'bottom',
                                        horizontalAlign: 'center',
                                        offsetY: 3,
                                        itemMargin: {
                                            horizontal: 10
                                        },
                                        containerMargin: {
                                            left: 20,
                                            right: 20
                                        },
                                        containerHeight: 25 // Set the height of the legend container
                                    },
                                    tooltip: {
                                        shared: !0,
                                        intersect: false
                                    }
                                };

                                self.charts[filial] = {
                                    'render': render,
                                    'obj': null
                                }
                            }, 1000);

                            let marketingData = {
                                'FILIAL': filial,
                                'TOTAL LEADS': data.funnel.funil_total,
                                'TOTAL LEADS (HUNTER)': data.funnel.funil_total_hunters,
                                'TOTAL LEADS (CLÍNICA)': data.funnel.funil_total_clinica,
                                'TOTAL LEADS (AMBOS)': data.funnel.funil_total_ambos,
                                'LEADS CONTATADOS': data.funnel.funil_entrou_em_contato,
                                'LEADS NÃO CONTATADOS': data.funnel.funil_nao_entrou_em_contato,
                                'PNs (Hunters)': data.current_total_scheduled,
                                'PITs (Hunters)': data.current_total_plan_sells_by_seller.TOTAL_PIT_HUNTER,
                                'PNs (Clínica)': data.current_total_scheduled_by_business_branch,
                                'PITs (Clínica)': data.current_total_plan_sells_by_seller.TOTAL_PIT_CLINICA,
                                'PRs': data.current_total_returnig_patients
                            };

                            // Merging the robot data into the main object
                            window._sessionData.organicAttendantList.forEach((v, i) => {
                                marketingData[`PNs (${v})`] = data[`current_total_scheduled_bot_${i}`];
                                marketingData[`PITs (${v})`] = data.current_total_plan_sells_by_seller[`TOTAL_PIT_ROBO_${i}`];
                            });

                            self.responses['MARKETING_FUNNEL_PER_SELLER_EXPORT'].push(marketingData);

                            let id = self.responses['MARKETING_FUNNEL_PER_SELLER_EXPORT'].length - 1;
                            // Merge extraExportOriginsData into the object at the index
                            self.responses['MARKETING_FUNNEL_PER_SELLER_EXPORT'][id] = {
                                ...self.responses['MARKETING_FUNNEL_PER_SELLER_EXPORT'][id],
                                ...extraExportOriginsData,
                                ...extraExportPITOriginsData,
                                'PNs': totalAttendendPNSum,
                                'PITs': data.current_total_plans_sells,
                                'PIMs': data.current_total_plans_maintenance_sells,
                                'PRs': data.current_total_returnig_patients,
                            };

                            //console.log('filial row', self.responses['MARKETING_FUNNEL_PER_SELLER_EXPORT']);

                            countTotalLeads = countTotalLeads + parseInt(data.funnel.funil_total);
                            countTotalLeadsHunter = countTotalLeadsHunter + parseInt(data.funnel.funil_total_hunters);
                            countTotalLeadsClinica = countTotalLeadsClinica + parseInt(data.funnel.funil_total_clinica);
                            countTotalLeadsAmbos = countTotalLeadsAmbos + parseInt(data.funnel.funil_total_ambos);
                            countTotaLeadsContatados = countTotaLeadsContatados + parseInt(data.funnel.funil_entrou_em_contato);
                            countTotalNaoLeadsContatados = countTotalNaoLeadsContatados + parseInt(data.funnel.funil_nao_entrou_em_contato);
                            countTotalPNHunter = countTotalPNHunter + parseInt(data.current_total_scheduled);
                            window._sessionData.organicAttendantList.map((v, i) => {
                                countTotalPNBot[i] = !countTotalPNBot[i] ? parseInt(data[`current_total_scheduled_bot_${i}`]) : countTotalPNBot[i] + parseInt(data[`current_total_scheduled_bot_${i}`]);
                            })
                            countTotalPlanSells = countTotalPlanSells + parseInt(data.current_total_plans_sells);
                            countTotalPlanMaintenanceSells = countTotalPlanMaintenanceSells + parseInt(data.current_total_plans_maintenance_sells);
                            countTotalPITHunter = countTotalPITHunter + parseInt(data.current_total_plan_sells_by_seller.TOTAL_PIT_HUNTER);
                            countTotalPITClinica = countTotalPITClinica + parseInt(data.current_total_plan_sells_by_seller.TOTAL_PIT_CLINICA);
                            window._sessionData.organicAttendantList.map((v, i) => {
                                countTotalPITRobo[i] = !countTotalPITRobo[i] ? parseInt(data.current_total_plan_sells_by_seller[`TOTAL_PIT_ROBO_${i}`]) : countTotalPITRobo[i] + parseInt(data.current_total_plan_sells_by_seller[`TOTAL_PIT_ROBO_${i}`]);
                            })
                            countTotalPNByBusinessBranh = countTotalPNByBusinessBranh + parseInt(data.current_total_scheduled_by_business_branch);
                            countTotalPN = countTotalPN + totalAttendendPNSum;
                            countTotalPR = countTotalPR + parseInt(data.current_total_returnig_patients);

                        }

                        /*console.log('countTotalPNBot', countTotalPNBot);
                        console.log('countTotalPITRobo', countTotalPITRobo);*/

                        /*console.log('countOriginsTotals', countOriginsTotals);
                        console.log('countOriginsTotals', Object.keys(countOriginsTotals));
                        console.log('countOriginsTotalsPIT', countOriginsTotalsPIT);
                        console.log('countOriginsTotalsPIT', Object.keys(countOriginsTotalsPIT));**/

                        let extraOriginsPerRowHTML = '';
                        let extraExportOriginsData = {};
                        let extraExportPITOriginsData = {};
                        let extraOrganicAttendantPerRowHTML = '';
                        countExtraOrigins = MARKETING_TABLE_STARt_COLUMNS_FROM;
                        //console.log('countOriginsTotals', countOriginsTotals);
                        for (let i = 0; i < window._sessionData.organicAttendantList.length; i++) {
                            let vb = window._sessionData.organicAttendantList[i];
                            extraOrganicAttendantPerRowHTML += `<td class="js-mkt-branches-funnel-column-${countExtraOrigins} ${window._sessionData.activeOrganicAttendantList.includes(window._sessionData.organicAttendantList[i]) ? '' : 'column-hideable'}" data-label="Total PNs (${vb})"><b>${countTotalPNBot[i]}</b></td>`;
                            countExtraOrigins++;
                            extraOrganicAttendantPerRowHTML += `<td class="js-mkt-branches-funnel-column-${countExtraOrigins} ${window._sessionData.activeOrganicAttendantList.includes(window._sessionData.organicAttendantList[i]) ? '' : 'column-hideable'}" data-label="Total PITs (${vb})"><b>${countTotalPITRobo[i]}</b></td>`;
                            countExtraOrigins++;
                        }

                        countExtraOrigins = countExtraOrigins - 1;

                        for (let i = 0; i < window._sessionData.origins.length; ++i) {
                            let origin = window._sessionData.origins[i];

                            if (origin.ID == 8) // ESSA CATEGORIA DEVE SER IGNORADA POIS TEM 2 ORIGENS COM NOME LEAD
                                continue;

                            let hasOriginData = 0;
                            for (let j = 0; j < Object.keys(countOriginsTotals).length; ++j) {
                                let originName = Object.keys(countOriginsTotals)[j];
                                if (origin.ORIGEM.toUpperCase() === 'INDICAÇÃO') {
                                    origin.ORIGEM = 'INDICACAO'
                                }
                                if (originName == origin.ORIGEM.toUpperCase()) {
                                    //console.log('originName', originName.toUpperCase(), origin.ORIGEM.toUpperCase(), Object.values(countOriginsTotals)[j])
                                    hasOriginData = Object.values(countOriginsTotals)[j];
                                    break;
                                }
                            }

                            //console.log('origin', origin.ORIGEM.toUpperCase(), hasOriginData, countOriginsTotals[origin.ORIGEM.toUpperCase()]);

                            extraOriginsPerRowHTML += `<td class="js-mkt-branches-funnel-column-${countExtraOrigins} column-hideable" data-label="Total PNs (${origin.ORIGEM})"><b>${hasOriginData}</b></td>`;
                            countExtraOrigins++;

                            extraExportOriginsData['PNs' + origin.ORIGEM.toUpperCase()] = hasOriginData;
                        }

                        for (let i = 0; i < window._sessionData.origins.length; ++i) {
                            let origin = window._sessionData.origins[i];

                            if (origin.ID == 8) // ESSA CATEGORIA DEVE SER IGNORADA POIS TEM 2 ORIGENS COM NOME LEAD
                                continue;

                            let hasOriginData = 0;
                            for (let j = 0; j < Object.keys(countOriginsTotalsPIT).length; ++j) {
                                let originName = Object.keys(countOriginsTotalsPIT)[j];
                                if (origin.ORIGEM.toUpperCase() === 'INDICAÇÃO') {
                                    origin.ORIGEM = 'INDICACAO'
                                }
                                if (originName == origin.ORIGEM.toUpperCase()) {
                                    //console.log('originName', originName.toUpperCase(), origin.ORIGEM.toUpperCase(), Object.values(countOriginsTotalsPIT)[j])
                                    hasOriginData = Object.values(countOriginsTotalsPIT)[j];
                                    break;
                                }
                            }

                            extraOriginsPerRowHTML += `<td class="js-mkt-branches-funnel-column-${countExtraOrigins} column-hideable" data-label="Total PITs (${origin.ORIGEM})"><b>${hasOriginData}</b></td>`;
                            countExtraOrigins++;

                            extraExportPITOriginsData['PITs ' + origin.ORIGEM.toUpperCase()] = hasOriginData;
                        }

                        let marketingTotalData = {
                            'FILIAL': 'Total',
                            'TOTAL LEADS': countTotalLeads,
                            'TOTAL LEADS (HUNTER)': countTotalLeadsHunter,
                            'TOTAL LEADS (CLÍNICA)': countTotalLeadsClinica,
                            'TOTAL LEADS (AMBOS)': countTotalLeadsAmbos,
                            'LEADS CONTATADOS': countTotaLeadsContatados,
                            'LEADS NÃO CONTATADOS': countTotalNaoLeadsContatados,
                            'PNs (Hunters)': countTotalPNHunter,
                            'PITs (Hunters)': countTotalPITHunter,
                            'PNs (Clínica)': countTotalPNByBusinessBranh,
                            'PITs (Clínica)': countTotalPITClinica,
                            'PRs': countTotalPR,
                        };

                        // Merging the robot data into the main object
                        window._sessionData.organicAttendantList.forEach((v, i) => {
                            marketingTotalData[`PNs (${v})`] = countTotalPNBot[i];
                            marketingTotalData[`PITs (${v})`] = countTotalPITRobo[i];
                        });

                        self.responses['MARKETING_FUNNEL_PER_SELLER_EXPORT'].push(marketingTotalData);
                        // Get the index of the newly added object
                        let id = self.responses['MARKETING_FUNNEL_PER_SELLER_EXPORT'].length - 1;
                        // Merge extraExportOriginsData into the object at the index
                        self.responses['MARKETING_FUNNEL_PER_SELLER_EXPORT'][id] = {
                            ...self.responses['MARKETING_FUNNEL_PER_SELLER_EXPORT'][id],
                            ...extraExportOriginsData,
                            ...extraExportPITOriginsData,
                            'PNs': countTotalPN,
                            'PITs': countTotalPlanSells,
                            'PIMs': countTotalPlanMaintenanceSells,
                            'PRs': countTotalPR,
                        };

                        $('.js-report-marketing-branches-funnel-footer').html(`<tr>
                            <td data-label="Total"><b>TOTAL:</b></td>
                            <td class="js-mkt-branches-funnel-column-1" data-label="Gráfico"></td>
                            <td class="js-mkt-branches-funnel-column-2" data-label="Total Leads"><b>${countTotalLeads}</b></td>
                            <td class="js-mkt-branches-funnel-column-3 column-hideable" data-label="Total Leads (Hunter)"><b>${countTotalLeadsHunter}</b></td>
                            <td class="js-mkt-branches-funnel-column-4 column-hideable" data-label="Total Leads (Clínica)"><b>${countTotalLeadsClinica}</b></td>
                            <td class="js-mkt-branches-funnel-column-5 column-hideable" data-label="Total Leads (Ambos)"><b>${countTotalLeadsAmbos}</b></td>
                            <td class="js-mkt-branches-funnel-column-6" data-label="Leads Contatados"><b>${countTotaLeadsContatados}</b></td>
                            <td class="js-mkt-branches-funnel-column-7" data-label="Leads Não Contatados"><b>${countTotalNaoLeadsContatados}</b></td>
                            <td class="js-mkt-branches-funnel-column-8 column-hideable" data-label="Total PNs (Hunters)"><b>${countTotalPNHunter}</b></td>
                            <td class="js-mkt-branches-funnel-column-9 column-hideable" data-label="Total PITs (Hunters)"><b>${countTotalPITHunter}</b></td>
                            <td class="js-mkt-branches-funnel-column-10" data-label="Total PNs (Clínica)"><b>${countTotalPNByBusinessBranh}</b></td>
                            <td class="js-mkt-branches-funnel-column-11" data-label="Total PITs (Clínica)"><b>${countTotalPITClinica}</b></td>
                            ${extraOrganicAttendantPerRowHTML}
                            ${extraOriginsPerRowHTML}
                            <td class="js-mkt-branches-funnel-column-${countExtraOrigins}" data-label="Total PNs"><b>${countTotalPN}</b></td>
                            <td class="js-mkt-branches-funnel-column-${countExtraOrigins + 1}" data-label="Total PITs"><b>${countTotalPlanSells}</b></td>
                            <td class="js-mkt-branches-funnel-column-${countExtraOrigins + 2}" data-label="Total PIMs"><b>${countTotalPlanMaintenanceSells}</b></td>
                            <td class="js-mkt-branches-funnel-column-${countExtraOrigins + 3}" data-label="Total PRs"><b>${countTotalPR}</b></td>
                        </tr>`);

                        $('.js-report-marketing-branches-funnel-list').append(html);

                        mountSortList('#table-js-report-marketing-branches-funnel-list', '.js-report-marketing-branches-funnel-list tr:first td', 1, 3)
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadMarketingLeadsHistoryChart() {
        let self = this;
        return new Promise((resolve, reject) => {
            //$("#js-report-marketing-branches-funnel-container").block(window._loader.loading);
            this.requests['MARKETING_DASHBOARD_LEADS_HISTORY'] = this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: {
                    report: 'MARKETING_DASHBOARD_LEADS_HISTORY',
                    period: self.periods.DASHBOARD,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);
                    console.log('dashboard.js/marketing/insights', 'MARKETING_DASHBOARD_LEADS_HISTORY', res);
                    const categories = res.results.current_month_leads_labels;

                    const series = [
                        {
                            name: 'Este Mês',
                            data: res.results.current_month_leads_data
                        },
                        {
                            name: 'Último Mês',
                            data: res.results.last_month_leads_data
                        }
                    ];

                    // Create the chart
                    var options = {
                        chart: {
                            type: 'bar',
                            height: 318,
                        },
                        series: series,
                        xaxis: {
                            categories: categories
                        },
                        // Set the tooltip formatter
                        tooltip: {
                            y: {
                                formatter: function (val) {
                                    return val + " leads" // Add percentage sign to progress value
                                }
                            },
                            x: {
                                formatter: function (val, opts) {
                                    // Format the date label according to the date bar
                                    var index = opts.dataPointIndex;
                                    var seriesIndex = opts.seriesIndex;
                                    var date;
                                    if (seriesIndex == 0) {
                                        // Current month
                                        date = new Date(); // Get the current date
                                        date.setDate(index + 1); // Set the date to the index + 1
                                    } else {
                                        // Last month
                                        date = new Date(); // Get the current date
                                        date.setMonth(date.getMonth() - 1); // Set the month to the previous one
                                        date.setDate(index + 1); // Set the date to the index + 1
                                    }
                                    return date.toLocaleDateString(); // Return the formatted date string
                                }
                            }
                        },
                        // Enable data labels
                        dataLabels: {
                            enabled: true,
                            formatter: function (val, opts) {
                                /*// Format the date label according to the date bar
                                var index = opts.dataPointIndex;
                                var seriesIndex = opts.seriesIndex;
                                var date;
                                if (seriesIndex == 0) {
                                  // Current month
                                  date = new Date(); // Get the current date
                                  date.setDate(index + 1); // Set the date to the index + 1
                                } else {
                                  // Last month
                                  date = new Date(); // Get the current date
                                  date.setMonth(date.getMonth() - 1); // Set the month to the previous one
                                  date.setDate(index + 1); // Set the date to the index + 1
                                }
                                return date.toLocaleDateString(); // Return the formatted date string*/
                            }
                        },
                        title: {
                            text: 'Comparação Leads Este Mês vs Último Mês',
                            align: 'center'
                        }
                    };

                    if (!self.charts.MARKETING_LEADS_COMPARISION) {
                        self.charts.MARKETING_LEADS_COMPARISION = new ApexCharts(document.querySelector("#js-report-marketing-leads-history-chart"), options);
                        self.charts.MARKETING_LEADS_COMPARISION.render();
                    } else {
                        self.charts.MARKETING_LEADS_COMPARISION.updateOptions(options);
                    }
                },
                errorCallback: function (err) {
                    reject(true);
                    console.error(err);
                }
            });
        });
    }

    loadMarketingLeadsConversion() {
        let self = this;
        return new Promise((resolve, reject) => {
            $("#js-report-marketing-leads-conversion").block(window._loader.loading);

            this.requests['MARKETING_REPORT_LEADS_CONVERSION'] = this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: {
                    report: 'MARKETING_REPORT_LEADS_CONVERSION',
                    period: self.periods.DASHBOARD,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);
                    console.log('dashboard.js/marketing/insights', 'MARKETING_REPORT_LEADS_CONVERSION', res);

                    $("#js-report-marketing-leads-conversion").unblock();
                    self.responses.MARKETING_REPORT_LEADS_CONVERSION = res.results;

                    // Calculate the percentages
                    const totalLeads = res.results.total_leads;
                    const totalSchedules = res.results.total_schedules;
                    const totalSchedulesAttended = res.results.total_scheduled_attended;
                    const totalSchedulesNotAttended = res.results.total_scheduled_not_attended;
                    const totalPlansSold = res.results.total_plans_sold;

                    const percentageScheduled = parseFloat((totalSchedules / totalLeads) * 100).toFixed(2);
                    const percentageAttended = parseFloat((totalSchedulesAttended / totalSchedules) * 100).toFixed(2);
                    const percentageNotAttended = parseFloat((totalSchedulesNotAttended / totalSchedules) * 100).toFixed(2);
                    const percentagePlansSold = parseFloat((totalPlansSold / totalSchedules) * 100).toFixed(2);

                    if (!res.error) {
                        var options = {
                            series: [
                                {
                                    name: "Funil",
                                    data: [
                                        totalLeads,
                                        totalSchedules,
                                        totalSchedulesNotAttended,
                                        totalSchedulesAttended,
                                        totalPlansSold,
                                    ],
                                },
                            ],
                            chart: {
                                type: 'bar',
                                height: 350,
                            },
                            plotOptions: {
                                bar: {
                                    borderRadius: 0,
                                    horizontal: true,
                                    barHeight: '80%',
                                    isFunnel: true,
                                },
                            },
                            dataLabels: {
                                enabled: true,
                                formatter: function (val, opt) {
                                    return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val
                                },
                                dropShadow: {
                                    enabled: true,
                                },
                            },
                            title: {
                                text: 'Funil Conversão de Leads',
                                align: 'middle',
                            },
                            xaxis: {
                                categories: [
                                    'Total de Leads - 100%',
                                    'Agendamentos - ' + (percentageScheduled) + '%',
                                    'PNs Não Atendidos - ' + (percentageNotAttended) + '%',
                                    'PNs Atendidos - ' + (percentageAttended) + '%',
                                    'PIT - ' + (percentagePlansSold) + '%'
                                ],
                            },
                            legend: {
                                show: false,
                            },
                        };

                        if (!self.charts.LEADS_CONVERSION_FUNNEL) {
                            self.charts.LEADS_CONVERSION_FUNNEL = new ApexCharts(document.querySelector("#js-report-marketing-leads-conversion"), options);
                            self.charts.LEADS_CONVERSION_FUNNEL.render();
                        } else {
                            self.charts.LEADS_CONVERSION_FUNNEL.updateOptions(options);
                        }
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadMarketingOrganicLeadsConversion() {
        let self = this;
        return new Promise((resolve, reject) => {
            $("#js-report-marketing-organic-leads-conversion").block(window._loader.loading);

            this.requests['MARKETING_REPORT_LEADS_CONVERSION_ORGANIC'] = this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: {
                    report: 'MARKETING_REPORT_LEADS_CONVERSION_ORGANIC',
                    period: self.periods.DASHBOARD,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);
                    console.log('dashboard.js/marketing/insights', 'MARKETING_REPORT_LEADS_CONVERSION_ORGANIC', res);

                    $("#js-report-marketing-organic-leads-conversion").unblock();
                    self.responses.MARKETING_REPORT_LEADS_CONVERSION_ORGANIC = res.results;

                    // Calculate the percentages
                    const totalLeads = res.results.total_leads;
                    const totalSchedules = res.results.total_schedules;
                    const totalSchedulesAttended = res.results.total_scheduled_attended;
                    const totalSchedulesNotAttended = res.results.total_scheduled_not_attended;
                    const totalPlansSold = res.results.total_plans_sold;

                    const percentageScheduled = parseFloat((totalSchedules / totalLeads) * 100).toFixed(2);
                    const percentageAttended = parseFloat((totalSchedulesAttended / totalSchedules) * 100).toFixed(2);
                    const percentageNotAttended = parseFloat((totalSchedulesNotAttended / totalSchedules) * 100).toFixed(2);
                    const percentagePlansSold = parseFloat((totalPlansSold / totalSchedules) * 100).toFixed(2);

                    if (!res.error) {
                        var options = {
                            series: [
                                {
                                    name: "Funil",
                                    data: [
                                        totalLeads,
                                        totalSchedules,
                                        totalSchedulesNotAttended,
                                        totalSchedulesAttended,
                                        totalPlansSold,
                                    ],
                                },
                            ],
                            chart: {
                                type: 'bar',
                                height: 350,
                            },
                            plotOptions: {
                                bar: {
                                    borderRadius: 0,
                                    horizontal: true,
                                    barHeight: '80%',
                                    isFunnel: true,
                                },
                            },
                            dataLabels: {
                                enabled: true,
                                formatter: function (val, opt) {
                                    return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val
                                },
                                dropShadow: {
                                    enabled: true,
                                },
                            },
                            title: {
                                text: 'Funil Conversão de Leads',
                                align: 'middle',
                            },
                            xaxis: {
                                categories: [
                                    'Total de Leads - 100%',
                                    'Agendamentos - ' + (percentageScheduled) + '%',
                                    'PNs Não Atendidos - ' + (percentageNotAttended) + '%',
                                    'PNs Atendidos - ' + (percentageAttended) + '%',
                                    'PIT - ' + (percentagePlansSold) + '%'
                                ],
                            },
                            legend: {
                                show: false,
                            },
                        };

                        if (!self.charts.ORGANIC_LEADS_CONVERSION_FUNNEL) {
                            self.charts.ORGANIC_LEADS_CONVERSION_FUNNEL = new ApexCharts(document.querySelector("#js-report-marketing-organic-leads-conversion"), options);
                            self.charts.ORGANIC_LEADS_CONVERSION_FUNNEL.render();
                        } else {
                            self.charts.ORGANIC_LEADS_CONVERSION_FUNNEL.updateOptions(options);
                        }
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadMarketingKPIs() {
        let self = this;
        return new Promise((resolve, reject) => {
            $("#js-report-marketing-kpis").block(window._loader.loading);

            this.requests['MARKETING_REPORT_KPIS'] = this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: {
                    report: 'MARKETING_REPORT_KPIS',
                    period: self.periods.DASHBOARD,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);
                    console.log('dashboard.js/marketing/insights', 'MARKETING_REPORT_KPIS', res);

                    $("#js-report-marketing-kpis").unblock();
                    self.responses.MARKETING_REPORT_KPIS = res.results;

                    if (!res.error) {
                        let investimentoFb = self.mktInvestmentsTotals['FACEBOOK'] || 0;
                        let investimentoGoog = self.mktInvestmentsTotals['GOOGLE'] || 0;
                        let qtdLead = 0;
                        let qtdGoogle = 0;

                        for (let i = 0; i < Object.keys(self.responses.MARKETING_DASHBOARD_METRICS.current_pn_origins).length; ++i) {
                            let item = Object.values(self.responses.MARKETING_DASHBOARD_METRICS.current_pn_origins)[i];
                            if (item.ORIGEM_NAME == 'Lead') {
                                qtdLead = parseInt(item.TOTAL_SCHEDULES);
                            } else if (item.ORIGEM_NAME == 'Google') {
                                qtdGoogle = parseInt(item.TOTAL_SCHEDULES);
                            }
                        }

                        $('.js-marketing-kpi-cac-lead').html(`R$` + (qtdLead == 0 ? 0 : parseFloat(investimentoFb / self.responses.MARKETING_DASHBOARD_METRICS.current_count_leads).toFixed(2)));
                        $('.js-marketing-kpi-cac-google').html(`R$` + (qtdGoogle == 0 ? 0 : parseFloat(investimentoGoog / qtdGoogle).toFixed(2)));

                        $('.js-marketing-kpi-roi-lead-pit-pn').html('R$' + res.results.soma_pit_pn.origem_lead.roi_lead);
                        $('.js-marketing-kpi-roi-google-pit-pn').html('R$' + res.results.soma_pit_pn.origem_google.roi_google);
                        $('.js-marketing-kpi-roas-lead-pit-pn').html(res.results.soma_pit_pn.origem_lead.roas_lead);
                        $('.js-marketing-kpi-roas-google-pit-pn').html(res.results.soma_pit_pn.origem_google.roas_google);
                        $('.js-marketing-kpi-cac-lead-pit-pn').html('R$' + res.results.soma_pit_pn.origem_lead.cac_lead);
                        $('.js-marketing-kpi-cac-google-pit-pn').html('R$' + res.results.soma_pit_pn.origem_google.cac_google);
                        $('.js-marketing-kpi-ltv-lead-pit-pn').html(`R$` + res.results.soma_pit_pn.origem_lead.lead_ltv);
                        $('.js-marketing-kpi-ltv-google-pit-pn').html(`R$` + res.results.soma_pit_pn.origem_google.google_ltv);

                        $('.js-marketing-kpi-roi-lead-pn').html('R$' + res.results.pn.origem_lead.roi_lead);
                        $('.js-marketing-kpi-roi-google-pn').html('R$' + res.results.pn.origem_google.roi_google);
                        $('.js-marketing-kpi-roas-lead-pn').html(res.results.pn.origem_lead.roas_lead);
                        $('.js-marketing-kpi-roas-google-pn').html(res.results.pn.origem_google.roas_google);
                        $('.js-marketing-kpi-cac-lead-pn').html('R$' + res.results.pn.origem_lead.cac_lead);
                        $('.js-marketing-kpi-cac-google-pn').html('R$' + res.results.pn.origem_google.cac_google);
                        $('.js-marketing-kpi-ltv-lead-pn').html(`R$` + res.results.pn.origem_lead.lead_ltv);
                        $('.js-marketing-kpi-ltv-google-pn').html(`R$` + res.results.pn.origem_google.google_ltv);

                        $('.js-marketing-kpi-roi-lead-pit').html('R$' + res.results.pit.origem_lead.roi_lead);
                        $('.js-marketing-kpi-roi-google-pit').html('R$' + res.results.pit.origem_google.roi_google);
                        $('.js-marketing-kpi-roas-lead-pit').html(res.results.pit.origem_lead.roas_lead);
                        $('.js-marketing-kpi-roas-google-pit').html(res.results.pit.origem_google.roas_google);
                        $('.js-marketing-kpi-cac-lead-pit').html('R$' + res.results.pit.origem_lead.cac_lead);
                        $('.js-marketing-kpi-cac-google-pit').html('R$' + res.results.pit.origem_google.cac_google);
                        $('.js-marketing-kpi-ltv-lead-pit').html(`R$` + res.results.pit.origem_lead.lead_ltv);
                        $('.js-marketing-kpi-ltv-google-pit').html(`R$` + res.results.pit.origem_google.google_ltv);
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    bindDomEvents() {
        let self = this;
        var rangeStartDate = moment().startOf('month'),
            rangeEndDate = moment().endOf('day');

        // Detecta seleção de data no date ranger picker do dashboard marketing
        $('input[name="daterange"]').daterangepicker({
            opens: 'left',
            startDate: rangeStartDate,
            endDate: rangeEndDate,
            opens: "right",
            drops: "down",
            locale: window._sessionData.i8nDateRangePicker,
            ranges: {
                'Hoje': [moment().startOf('day'), moment().endOf('day')],
                'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Amanhã': [moment().add(1, 'days'), moment().add(1, 'days')],
                'Últimos 7 Dias': [moment().subtract(6, 'days'), moment()],
                'Últimos 30 Dias': [moment().subtract(29, 'days'), moment()],
                'Este Mês': [moment().startOf('month'), moment().endOf('month')],
                'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
        }, function (start, end, label) {
            //console.log("A new date selection was made: " + start.format('YYYY-MM-DD 00:00:00.000') + ' to ' + end.format('YYYY-MM-DD 00:00:00.000'));
            self.periods['DASHBOARD'] = `${start.format('YYYY-MM-DD 00:00:00.000')}|${end.format('YYYY-MM-DD 00:00:00.000')}`;

            self.clearAllRequests();

            self.loadMarketingMetrics(false)
                .then(() => {
                    console.log('rerender loadMarketingMetrics report')
                })
                .then(() => {
                    self.loadMarketingLastLeads(false)
                    self.loadMarketingGeneralFunnel(false)
                    self.loadMarketingPerSellerFunnel(false)
                    self.loadMarketingLeadsHistoryChart(false)
                    self.loadMarketingKPIs(false)
                });
        });

        // Detecta clique para exportar relatório de funil por unidade
        $('.js-marketing-dashboard-export-funnel-by-branch').click(function (e) {
            e.preventDefault();
            let data = self.responses.MARKETING_FUNNEL_PER_SELLER_EXPORT;

            let newData = data;
            for (let i in data) {
                let keys = Object.keys(data[i]);

                for (let j in keys) {
                    if (keys[j] === 'FILIAL') {
                        continue;
                    }

                    if ($('.js-mkt-branches-funnel-column-' + (parseInt(j) + 1)).hasClass('column-hideable')) {
                        delete newData[i][keys[j]];
                    }
                }
            }

            const worksheet = XLSX.utils.json_to_sheet(data);

            // Create a workbook and add the worksheet to it
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // Export the workbook to an Excel file
            XLSX.writeFile(workbook, 'relatorio_funil_unidade_' + window.getSaoPauloDateTime() + '.xlsx');

            window.toast({
                error: false,
                text: "Exportação realizada com sucesso."
            })
        });

        // Detecta clique para mostrar gráfico de desempenho de uma unidade
        $(document).on('click', '.js-marketing-view-branch-data', function (e) {
            e.preventDefault();
            let filialNome = $(this).data('filial');

            $("#modal-marketing-dashboard-view-branch-pit-pn-graphic").modal('show');
            $('.js-marketing-dashboard-branch-pit-pn-graphic-dialog-title-id').html(filialNome);

            self.charts[filialNome].obj = new ApexCharts(document.querySelector(".js-view-marketing-dashboard-branch-pit-pn-graphic-container"), self.charts[filialNome].render);
            self.charts[filialNome].obj.render();
        });

        // Detecta clique para abrir o gráfico de leads por hora da unidade
        $(document).on('click', '.js-report-row-marketing-branches-funnel-option', function () {
            let filial = $(this).data('filial') ? $(this).data('filial') : false;

            $("#modal-marketing-dashboard-view-branch-leads-per-hour").modal('show');
            $('.js-marketing-dashboard-view-branch-leads-per-hour-dialog-title').html('Visualizar Relatório de Leads Por Hora da Filial' + (filial ? filial : 'TODAS'));
            $(`.js-view-marketing-dashboard-view-branch-leads-per-hour-container`).html(`
                <div class="col-12 mb-3 js-view-business-branch-report-new-patient-content">
                    Carregando...
                </div>
            `);
            $('.js-view-marketing-dashboard-view-branch-leads-per-hour-container').block(window._loader.loading);

            var payload = {
                report: 'MARKETING_REPORT_LEADS_PER_HOUR_BY_DATE_INTERVAL',
                period: self.periods.DASHBOARD
            };
            if (filial) {
                payload.branchName = filial;
            }

            self.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: payload,
                successCallback: function (res) {
                    console.log('dashboard.js/marketing/insights', 'MARKETING_REPORT_LEADS_PER_HOUR_BY_DATE_INTERVAL', res);
                    $(".js-view-marketing-dashboard-view-branch-leads-per-hour-container").unblock();

                    $(`.js-view-marketing-dashboard-view-branch-leads-per-hour-container`).html(`
                        <div class="accordion mb-3 js-view-marketing-dashboard-view-branch-leads-per-hour-accordion" id="accordionMarketingDashboardReportBranchLeadsPerHour"></div>
                    `);

                    if (!res.error) {
                        /*let html = '',
                            countIdx = 0,
                            countTotalLeads = 0,
                            countTotaLeadsContatados = 0,
                            countTotalNaoLeadsContatados = 0,
                            countTotalPN = 0,
                            countTotalPNHunter = 0,
                            countTotalPNBot = 0,
                            countTotalPNByBusinessBranh = 0,
                            countTotalPIT = 0,
                            foundBranches = [],
                            notFoundBranches = [],
                            countTotalPlanSells = 0;*/

                        for (let i = 0; i < Object.entries(res.results).length; ++i) {
                            const dia = Object.keys(res.results)[i];
                            const data = Object.entries(res.results)[i][1];

                            $(`.js-view-marketing-dashboard-view-branch-leads-per-hour-accordion`).append(`
                                <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-button text-white collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMktDashboardReportBranchLeadsPerHour${dia}" aria-expanded="true" aria-controls="collapseMktDashboardReportBranchLeadsPerHour${dia}">
                                                ${dia}
                                            </button>
                                        </h2>
                                        <div id="collapseMktDashboardReportBranchLeadsPerHour${dia}" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionMarketingDashboardReportBranchLeadsPerHour">
                                            <div class="accordion-body">
                                                <table class="tableFixHead mb-0 table table-bordered table-striped table-dark table-hover responsive-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Hora</th>
                                                            <th>Leads Recebidos</th>
                                                            <th>Leads Contatados</th>
                                                            <th>Leads Não Contatados</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="js-view-marketing-dashboard-view-branch-leads-per-hour-table-${i}">
                                                        <tr><td colspan="4">Carregando...</td></tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            `);

                            let htmlHours = '';
                            let totalCount = 0;
                            for (let x = 0; x < data.length; x++) {
                                let hourData = data[x];
                                htmlHours += `
                                    <tr>
                                        <td>${hourData.current_hour}:00</td>
                                        <td>${hourData.info_leads.total_leads}</td>
                                        <td>${hourData.info_leads.funil_entrou_em_contato}</td>
                                        <td>${hourData.info_leads.funil_nao_entrou_em_contato}</td>
                                    </tr>
                                `;
                                totalCount = totalCount + parseInt(hourData.info_leads.total_leads);
                            }
                            htmlHours += `<tr>
                                <td coslpan="4">Total ${totalCount}</td>
                            </tr>`;
                            $(`.js-view-marketing-dashboard-view-branch-leads-per-hour-table-${i}`).html(htmlHours);
                        }
                    }
                },
                errorCallback(err) {
                    $(".js-view-marketing-dashboard-view-branch-leads-per-hour-container").block(window._loader.error);
                }
            });
        });

        // Detecta clique para abrir o gráfico de leads por hora da unidade
        $('.js-marketing-dashboard-leads-per-hour').click(function () {
            let filial = $(this).data('filial') ? $(this).data('filial') : false;

            // TODO: Abrir modal de leads por hora, com a lista de dias dentro do
            // período selecionado, dentro dos dias, o usuário clica e mostra a qtd
            // de leads por hora daquele dia naquela unidade
            $("#modal-marketing-dashboard-view-branch-leads-per-hour").modal('show');
            $('.js-marketing-dashboard-view-branch-leads-per-hour-dialog-title').html('Visualizar Relatório de Leads Por Hora da Filial' + (filial ? filial : 'TODAS'));
            $(`.js-view-marketing-dashboard-view-branch-leads-per-hour-container`).html(`
                <div class="col-12 mb-3 js-view-business-branch-report-new-patient-content">
                    Carregando...
                </div>
            `);
            $('.js-view-marketing-dashboard-view-branch-leads-per-hour-container').block(window._loader.loading);

            var payload = {
                report: 'MARKETING_REPORT_LEADS_PER_HOUR_BY_DATE_INTERVAL',
                period: self.periods.DASHBOARD
            };
            if (filial) {
                payload.branchName = filial;
            }

            self.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: payload,
                successCallback: function (res) {
                    console.log('dashboard.js/marketing/insights', 'MARKETING_REPORT_LEADS_PER_HOUR_BY_DATE_INTERVAL', res);
                    $(".js-view-marketing-dashboard-view-branch-leads-per-hour-container").unblock();

                    $(`.js-view-marketing-dashboard-view-branch-leads-per-hour-container`).html(`
                        <div class="accordion mb-3 js-view-marketing-dashboard-view-branch-leads-per-hour-accordion" id="accordionMarketingDashboardReportBranchLeadsPerHour"></div>
                    `);

                    if (!res.error) {
                        /*let html = '',
                            countIdx = 0,
                            countTotalLeads = 0,
                            countTotaLeadsContatados = 0,
                            countTotalNaoLeadsContatados = 0,
                            countTotalPN = 0,
                            countTotalPNHunter = 0,
                            countTotalPNBot = 0,
                            countTotalPNByBusinessBranh = 0,
                            countTotalPIT = 0,
                            foundBranches = [],
                            notFoundBranches = [],
                            countTotalPlanSells = 0;*/

                        for (let i = 0; i < Object.entries(res.results).length; ++i) {
                            const dia = Object.keys(res.results)[i];
                            const data = Object.entries(res.results)[i][1];

                            $(`.js-view-marketing-dashboard-view-branch-leads-per-hour-accordion`).append(`
                                <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-button text-white collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMktDashboardReportBranchLeadsPerHour${dia}" aria-expanded="true" aria-controls="collapseMktDashboardReportBranchLeadsPerHour${dia}">
                                                ${dia}
                                            </button>
                                        </h2>
                                        <div id="collapseMktDashboardReportBranchLeadsPerHour${dia}" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionMarketingDashboardReportBranchLeadsPerHour">
                                            <div class="accordion-body">
                                                <table class="tableFixHead mb-0 table table-bordered table-striped table-dark table-hover responsive-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Hora</th>
                                                            <th>Leads Recebidos</th>
                                                            <th>Leads Contatados</th>
                                                            <th>Leads Não Contatados</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="js-view-marketing-dashboard-view-branch-leads-per-hour-table-${i}">
                                                        <tr><td colspan="4">Carregando...</td></tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            `);

                            let htmlHours = '';
                            let totalCount = 0;
                            for (let x = 0; x < data.length; x++) {
                                let hourData = data[x];
                                htmlHours += `
                                    <tr>
                                        <td>${hourData.start_hour}:00 ~ ${hourData.current_hour}:00</td>
                                        <td>${hourData.info_leads.total_leads}</td>
                                        <td>${hourData.info_leads.funil_entrou_em_contato}</td>
                                        <td>${hourData.info_leads.funil_nao_entrou_em_contato}</td>
                                    </tr>
                                `;
                                totalCount = totalCount + parseInt(hourData.info_leads.total_leads);
                            }
                            htmlHours += `<tr>
                                <td coslpan="4">Total ${totalCount}</td>
                            </tr>`;
                            $(`.js-view-marketing-dashboard-view-branch-leads-per-hour-table-${i}`).html(htmlHours);
                        }
                    }
                },
                errorCallback(err) {
                    $(".js-view-marketing-dashboard-view-branch-leads-per-hour-container").block(window._loader.error);
                }
            });
        });

        // Detecta edição de colunas visíveis
        $('.js-report-marketing-branches-funnel-categories').select2({
            allowClear: true,
        });

        // Detecta clique para filtrar "Relatório Agenda" por uma categoria específica
        var shownKeys = [1, 2, 6, 7, 10, 11, 16, 17, 18, 19, 62, 63, 64];
        $('.js-report-marketing-branches-funnel-categories').change(function () {
            if (shownKeys.length > 0) {
                for (let i in shownKeys) {
                    let key = shownKeys[i];
                    if (!key)
                        continue;
                    $(`.js-mkt-branches-funnel-column-${key}`).addClass('column-hideable');
                    shownKeys[i] = null;
                }
            }

            for (let i in $(this).val()) {
                let key = $(this).val()[i];
                $(`.js-mkt-branches-funnel-column-${key}`).removeClass('column-hideable');
                shownKeys.push(key);
            }
        });

        // Detecta clique para abrir o gráfico de leads por hora da unidade
        $(document).on('click', '.js-report-marketing-pn-schedules-origins', function () {
            let filial = $(this).data('origin-id') ? $(this).data('origin-id') : false;
            let type = $(this).data('type') ? $(this).data('type') : false;

            $("#modal-marketing-dashboard-view-branch-leads-per-hour").modal('show');
            $('.js-marketing-dashboard-view-branch-leads-per-hour-dialog-title').html('Visualizar Relatório de Origens por Filial, filtrado pela origem: ' + (filial ? filial : 'TODAS'));
            $(`.js-view-marketing-dashboard-view-branch-leads-per-hour-container`).html(`
                <div class="col-12 mb-3 js-view-business-branch-report-new-patient-content">
                    Carregando...
                </div>
            `);
            $('.js-view-marketing-dashboard-view-branch-leads-per-hour-container').block(window._loader.loading);

            var payload = {
                report: 'MARKETING_REPORT_PATIENTS_BY_ORIGINS_AND_BRANCHES',
                period: self.periods.DASHBOARD,
                franchise: self.onlyFranchise
            };
            //if (filial) {
            payload.originId = filial;
            payload.type = type;
            //}

            self.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/marketing/insights',
                data: payload,
                successCallback: function (res) {
                    console.log('dashboard.js/marketing/insights', 'MARKETING_REPORT_PATIENTS_BY_ORIGINS_AND_BRANCHES', res);
                    $(".js-view-marketing-dashboard-view-branch-leads-per-hour-container").unblock();

                    const hasRobosData = res.results.current_origins_robos?.length > 0;

                    $(`.js-view-marketing-dashboard-view-branch-leads-per-hour-container`).html(`
                        <table class="mb-0 table table-bordered table-striped table-hover responsive-table">
                            <thead>
                                <tr>
                                    <th>Filial</th>
                                    ${hasRobosData ? '<th>Robôs</th>' : ''}
                                    <th>${hasRobosData ? 'Clínica' : 'Qtd'}</th>
                                    ${hasRobosData ? '<th>Total</th>' : ''}
                                </tr>
                            </thead>
                            <tbody class="js-report-mkt-pn-schedules-origins">
                                <tr><td colspan="5">Carregando...</td></tr>
                            </tbody>
                        </table>
                    `);

                    //if (!res.error) {
                    let tableHtml = '';
                    if (!Array.isArray(window._sessionData.businessBranches)) {
                        // convert to array
                        window._sessionData.businessBranches = Object.values(window._sessionData.businessBranches);
                    }

                    let sumTotals = {
                        total_schedules: 0,
                        total_robos: 0
                    };

                    // Criar um objeto para armazenar os dados de todas as filiais
                    let branchData = {};

                    // Processar current_origins
                    for (let i = 0; i < res.results.current_origins.length; ++i) {
                        const data = res.results.current_origins[i];

                        let branchName = '';
                        for (let j = 0; j < window._sessionData.businessBranches.length; ++j) {
                            if (window._sessionData.businessBranches[j].ID == data.FILIAL_ID) {
                                branchName = window._sessionData.businessBranches[j].FILIAL;
                                break;
                            }
                        }
                        if (branchName == '')
                            continue;

                        if (!branchData[data.FILIAL_ID]) {
                            branchData[data.FILIAL_ID] = {
                                FILIAL_ID: data.FILIAL_ID,
                                TOTAL_SCHEDULES: data.TOTAL_SCHEDULES,
                                TOTAL_ROBOS: 0
                            };
                        } else {
                            branchData[data.FILIAL_ID].TOTAL_SCHEDULES = data.TOTAL_SCHEDULES;
                        }
                        sumTotals.total_schedules += data.TOTAL_SCHEDULES;
                    }

                    // Processar current_origins_robos se existir
                    if (hasRobosData) {
                        for (let i = 0; i < res.results.current_origins_robos.length; ++i) {
                            const data = res.results.current_origins_robos[i];

                            let branchName = '';
                            for (let j = 0; j < window._sessionData.businessBranches.length; ++j) {
                                if (window._sessionData.businessBranches[j].ID == data.FILIAL_ID) {
                                    branchName = window._sessionData.businessBranches[j].FILIAL;
                                    break;
                                }
                            }
                            if (branchName == '')
                                continue;

                            if (!branchData[data.FILIAL_ID]) {
                                branchData[data.FILIAL_ID] = {
                                    FILIAL_ID: data.FILIAL_ID,
                                    TOTAL_SCHEDULES: 0,
                                    TOTAL_ROBOS: data.TOTAL_SCHEDULES
                                };
                            } else {
                                branchData[data.FILIAL_ID].TOTAL_ROBOS = data.TOTAL_SCHEDULES;
                            }
                            sumTotals.total_robos += data.TOTAL_SCHEDULES;
                        }
                    }


                    // Gerar o HTML da tabela
                    for (let filialId in branchData) {
                        let data = branchData[filialId];
                        let branchName = '';

                        for (let j = 0; j < window._sessionData.businessBranches.length; ++j) {
                            if (window._sessionData.businessBranches[j].ID == data.FILIAL_ID) {
                                branchName = window._sessionData.businessBranches[j].FILIAL;
                                break;
                            }
                        }

                        if (branchName != '') {
                            tableHtml += `
                                    <tr>
                                        <td data-label="Filial">${branchName}</td>
                                        ${hasRobosData ? `<td data-label="Robôs">${data.TOTAL_ROBOS}</td>` : ''}
                                        <td data-label="${hasRobosData ? 'Clínica' : 'Qtd'}">${data.TOTAL_SCHEDULES}</td>
                                        ${hasRobosData ? `<td data-label="Total">${data.TOTAL_ROBOS + data.TOTAL_SCHEDULES}</td>` : ''}
                                    </tr>
                                `;
                        }
                    }

                    // Adicionar a linha de totais
                    tableHtml += `
                            <tr>
                                <td data-label="Filial">Total</td>
                                ${hasRobosData ? `<td data-label="Robôs">${sumTotals.total_robos}</td>` : ''}
                                <td data-label="${hasRobosData ? 'Clínica' : 'Qtd'}">${sumTotals.total_schedules}</td>
                                ${hasRobosData ? `<td data-label="Total">${sumTotals.total_robos + sumTotals.total_schedules}</td>` : ''}
                            </tr>
                        `;

                    $('.js-report-mkt-pn-schedules-origins').html(tableHtml);
                    //}
                },
                errorCallback(err) {
                    $(".js-view-marketing-dashboard-view-branch-leads-per-hour-container").block(window._loader.error);
                }
            });
        });

        $(document).on('submit', '.js-mkt-insert-investment-form', function () {
            let form = $(this);
            let data = form.serializeArray();
            let payload = {};
            for (let i in data) {
                payload[data[i].name] = data[i].value;
            }

            self.deps.apiCall({
                method: 'PUT',
                endpoint: 'api/v1/marketing/invesment',
                data: payload,
                successCallback: function (res) {
                    console.log('dashboard.js/marketing/insights', 'MARKETING_INSERT_INVESTMENT', res);
                    if (!res.error) {
                        self.loadMarketingMetrics();
                        $("#mkt_insert_invesment_facebook_invesment").val('');
                        $("#mkt_insert_invesment_google_invesment").val('');
                        $("#mkt_insert_invesment_social_invesment").val('');
                        $("#mkt_insert_invesment_whatsapp_invesment").val('');

                        window.toast({
                            text: "Investimento cadastrado com sucesso.",
                            error: false
                        });
                    }
                },
                errorCallback: function (err) {
                    console.error(err);
                }
            });

            return false;
        });

        $(document).on('click', '#js-only-franchise', async function () {
            self.onlyFranchise = !self.onlyFranchise;
            console.log('self.onlyFranchise', self.onlyFranchise);

            self.clearAllRequests();

            self.loadMarketingMetrics(false)
                .then(() => {
                    console.log('render loadMarketingMetrics report')
                })
                .then(() => {
                    self.loadMarketingLastLeads(true)
                    self.loadMarketingGeneralFunnel(true)
                    self.loadMarketingPerSellerFunnel(true)
                    self.loadMarketingLeadsHistoryChart(false)
                    self.loadMarketingKPIs(false)
                    //self.loadMarketingLeadsConversion()
                    //self.loadMarketingOrganicLeadsConversion()
                });
        });
    }

    clearAllRequests() {
        for (let i in this.requests) {
            if (this.requests[i]) {
                this.requests[i].abort();
                this.requests[i] = null;
                delete this.requests[i];
            }
        }
    }
}